<template>
  <b-container class="mb-3">
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="6" sm="12" class="mt-2">
          <div style="padding: 10px;border: 2px solid #c4c6be;border-radius: 15px;">
            <b-form-group
              id="exampleInputGroup2"
              label-cols="3"
              label="Bank Name*"
              label-size="sm"
              label-for="inpbankName"
            >
              <b-form-select
                id="inpbankName"
                :options="Banks"
                value-field="BankID"
                text-field="BankName"
                required
                size="sm"
                @change.native="filterBranches"
                v-model="form.BankID"
              ></b-form-select>
            </b-form-group>
            <!-- <b-form-group
              id="exampleInputGroup2"
              label-cols="3"
              label="Branch Name*"
              label-size="sm"
              label-for="inpbranchName"
            >
              <b-form-select
                id="inpbranchName"
                :options="Branches"
                value-field="BankBranchID"
                text-field="BranchName"
                required
                size="sm"
                v-model="form.BranchID"
              ></b-form-select>
            </b-form-group>-->
            <b-form-group
              id="exampleInputGroup2"
              label-cols="3"
              label="Branch Name*"
              label-size="sm"
              label-for="inpbranchName"
            >
              <b-form-input
                id="inpBrName"
                type="text"
                v-model="form.BranchName"
                size="sm"
                required
                placeholder="Branch Name"
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group
              id="exampleInputGroup2"
              label-cols="3"
              label="City*"
              label-size="sm"
              label-for="inpCity"
            >
              <b-form-input
                id="inpCity"
                type="text"
                v-model="form.City"
                size="sm" required
                placeholder="city"
              ></b-form-input>
            </b-form-group>-->
            <b-form-group
              id="iGpdt"
              label-cols="3"
              label="Sanction Date"
              label-size="sm"
              label-for="inpDt"
            >
              <date-picker
                v-model="SanctionDate"
                format="DD-MM-YYYY"
                lang="en"
                required
                size="small"
              ></date-picker>
            </b-form-group>

            <div id="isdata">
              <b-form-group
                id="iGpTnr"
                label-cols="3"
                label="Loan Tenure (Months)*"
                label-size="sm"
                label-for="inpTenure"
              >
                <b-form-input
                  id="inpTenure"
                  type="number"
                  min="1"
                  max="60"
                  v-model="form.LoanTenure"
                  size="sm"
                  required
                  placeholder="Tenure"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="iGpRoi"
                label-cols="3"
                label="Rate of Interest % *"
                label-size="sm"
                label-for="inpRoi"
              >
                <b-form-input
                  id="inpRoi"
                  type="number"
                  min="1.0"
                  max="20.0"
                  step="0.05"
                  v-model="form.ROI"
                  size="sm"
                  required
                  placeholder="Rate of Interest %"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup2"
                label-cols="3"
                label="Loan Amount Rs.*"
                label-size="sm"
                label-for="inpAmount"
              >
                <b-form-input
                  id="inpAmount"
                  type="number"
                  :min="minAmountLn"
                  :max="maxAmountLn"
                  v-model="form.SanctionAmount"
                  size="sm"
                  required
                  placeholder="Loan Amount Rs."
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="row">
              <div class="col-md-4">
                <span class="ln-eng" style="font-size: 0.875rem;">Loan Sanction Letter *</span>
                <p
                  style="font-size: 0.75rem;color:#2284ab;"
                >Provisional Sanction Letter NOT accepted</p>
              </div>
              <div
                class="col-md-4"
                v-if="form.UploadSanctionLetter!='' && form.UploadSanctionLetter"
              >
                <a :href="getImgUrl2(form.UploadSanctionLetter)" target="_blank">
                  <img
                    style="height:30px"
                    :src="getImgUrl(form.UploadSanctionLetter)"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('sanctionLetter', form.UploadSanctionLetter)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile && showButton"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiPhotoPath"
                  @change="onFileChange10"
                  v-if="form.UploadSanctionLetter =='' || !form.UploadSanctionLetter"
                  accept=".jpg, .png, .gif, .pdf"
                  size="sm"
                  required
                  v-model="Photo"
                  class="mt-3"
                  plain
                ></b-form-file>
                <Spinner size="16" message="Loading..." v-if="isLoadingImg"></Spinner>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2 justify-content-md-center" v-if="!getUser.LockProfile">
        <b-col md="4" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col md="5" sm="12" style="text-align:right">
          <b-button type="submit" variant="primary" v-if="showButton">Submit</b-button>
          <b-button type="reset" variant="danger" v-if="showButton">Reset</b-button>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import * as _ from "lodash";
import Spinner from "vue-simple-spinner";
import axios from "axios";
import Formatter from "@/Formatter";
import lambda from "@/apis/lambda";
import DatePicker from "vue2-datepicker";
import store from '../../store'
const _SheetJSFT = ["jpeg", "jpg", "png", "pdf"];
export default {
  props: ["Loantype"],
  components: { Spinner, DatePicker },
  data() {
    return {
      Photo: null,
      BankID: "",
      SanctionDate: null,
      form: {
        BranchID: "00000000-0000-0000-0000-000000000000",
        LoanSanctionID: "00000000-0000-0000-0000-000000000000",
        LoginID: "00000000-0000-0000-0000-000000000000",
        LoanApplicationID: null,
        SanctionAmount: 0,
        LoanTenure: 0,
        ROI: 0.0,
        SanctionDate: null,
        VerifiedStatus: true,
        UploadSanctionLetter: "",
        BankID: 0,
        BranchName: ""
      },
      isValue: false,
      isSaved: false,
      show: true,
      showButton: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      isLoadingImg: false,
      modalInfo: "",
      selecteObj: {
        Document: "",
        Path: ""
      },
      minAmountLn:"",
      maxAmountLn:"",
      Banks: [],
      Branches: []
    };
  },
  methods: {
    onFileChange10(e) {
      this.isLoadingImg = true;
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.fiPhotoPath.reset();
        this.isLoadingImg = false;
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = files[0].type;
      var filepath = userid+"!!~~!!"+"sanctionLetter_." + extn;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let data = new FormData();
      let file = e.target.files[0];

    data.append('file', file,filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }

    axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)

    // axios.post('http://localhost:51169/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            // this.alertText = "Photo uploaded Successfully\n";
            // this.variant = "success";
            // this.showDismissibleAlert = true;
            this.form.UploadSanctionLetter = res.data;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoadingImg = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoadingImg = false;
        });
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      debugger;
      this.form.UploadSanctionLetter = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      let promise = apis.saveLoanDocumentPath(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            // if (this.docTbl.length > 0) {
            //   this.loadLoanImageList();
            // }
            this.$refs.fiPhotoPath.reset();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    deleteDocument2(document, path) {
      //console.log(item);
      debugger;
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.showDismissibleAlert = false;
      this.isLoading = true;

      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      this.form.SanctionDate = Formatter.convertDateFormatYMD(
        this.SanctionDate
      );
      this.form.LoanApplicationID = this.$store.getters.getApplicationID;
      if (this.form.UploadSanctionLetter == "") {
        this.alertText = "Please Upload Sanction Letter.";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      let promise = apis.saveSanctionLetter(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            if (response.body == "99999999-0000-0000-0000-000000000000") {
              this.alertText =
                "Sanction Letter not accepted. Sanction Date Can Not be prior to LOI Date";
              this.isSaved = false;
              this.variant = "warning";
              this.showDismissibleAlert = true;
            } else {
              this.alertText = "Data Saved Successfully";
              this.isSaved = true;
              this.variant = "success";
              this.showDismissibleAlert = true;
            }
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          console.error(err);
          if (err.body) {
            this.alertText = err.body;
          } else {
            this.alertText = err.message;
          }
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
    filterBranches(evt) {
      let id = evt.target.value;
      this.getBranches(id);
    },
    getBranches(bankID) {
      let promise = apis.ReadBankBranch(bankID);

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.Branches = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.Banks = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    ReadSanctionLetter() {

      let userid = this.$store.getters.loggedUser.UserId;

      let promise = apis.ReadSanctionLetterByUserID(userid);

      promise
        .then(response => {
          if (response.status == 200) {
            var userinfo = this.$store.getters.loggedUser;
           let promise2 =apis.ReadUserDetailByIndivisual(userinfo.UserId);
           promise2
        .then(response2 => {

          if (response2.status == 200) {
            for (var i = 0; i < response2.body.LoanApplication.length; i++) {
              let lonatypetemp=response2.body.LoanApplication[i].LoanType;

            if (lonatypetemp == 2 || lonatypetemp=='2') {
              console.log('in group');
              this.minAmountLn = 1000000;
              this.maxAmountLn = 5000000;

            }
            else  if (lonatypetemp == 1  || lonatypetemp=='1') {
              this.minAmountLn = 100000;
              this.maxAmountLn = 1500000;
            }
            else  if (lonatypetemp == 3 || lonatypetemp=='3') {
              console.log('in education');
              this.minAmountLn = 100000;
              this.maxAmountLn = 2000000;

            }
          }
          }
        });
            if (
              response.body.LoanSanctionID !=
              "00000000-0000-0000-0000-000000000000"
            ) {
              this.SanctionDate = response.body.SanctionDate;
              this.form = response.body;
              this.isLoading = false;
              this.showButton = false;
              this.$store.dispatch("setSanctionLetter", this.LoanDetails);
            }
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  computed: {
    getUser() {
      let x = this.$store.getters.getUserData;
      let OrganizationName = "";
      let ProductfromOrganization = "";
      let OrganizationAddress = "";
      let AmountFromBank = 0;

      return {
        LockProfile: x.LockProfile || false
      };
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.ReadBanks();
      this.ReadSanctionLetter();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LoanDisbursal/SanctionLetter.vue